var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{ref:_vm.refButtton,class:_vm.buttonClass,on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click')}}},[_c('icon',{attrs:{"name":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }